<template>
  <b-overlay :show="isLoading">
    <b-row v-if="languageDetails">
      <b-col cols="12">
        <b-card>
          <h1>ویرایش زبان</h1>
          <b-form class="p-2" @submit.prevent>
            <b-row>
              <b-col cols="12" md="6">
                <!-- Language Eng Title -->
                <b-form-group label="نام انگلیسی زبان" label-for="lang-eng">
                  <b-form-input
                    id="lang-eng"
                    v-model="languageDetails.title"
                    trim
                    placeholder="English"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <!-- Language Persian Title -->
                <b-form-group label="نام فارسی زبان" label-for="persian-title">
                  <b-form-input
                    id="persian-title"
                    v-model="languageDetails.persianTitle"
                    trim
                    placeholder="انگلیسی"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="mb-0"
                  label="توضیحات زبان"
                  label-for="description"
                >
                  <quillEditor
                    id="description"
                    class="mt-1"
                    v-model="languageDetails.description"
                    :options="editorOption"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" class="my-1">
                <b-form @submit.prevent>
                  <b-form-group label="کاور زبان" label-for="imageFile">
                    <b-form-file
                      id="imageFile"
                      v-model="imageFile"
                      accept="image/*"
                      @input="handleImageFile"
                    ></b-form-file>
                  </b-form-group>
                </b-form>
              </b-col>
              <b-col cols="12" md="6" class="my-1">
                <div v-if="imagePreview">
                  <p>پیشنمایش تصویر زبان</p>
                  <div class="position-relative">
                    <img
                      style="
                        width: 100%;
                        max-height: 20rem;
                        object-fit: contain;
                      "
                      :src="imagePreview"
                      alt=""
                    />
                    <!-- <feather-icon
                      icon="Trash2Icon"
                      size="25"
                      class="text-danger position-absolute"
                      style="left: 1rem; top: 1rem; cursor: pointer"
                      @click="deletePreviewImage"
                    /> -->
                  </div>
                </div>
              </b-col>
              <b-col cols="12" class="mt-2">
                <div class="d-flex align-items-center justify-content-end">
                  <b-button
                    variant="primary"
                    @click="sendUpdateLanguageRequest"
                  >
                    ویرایش
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BFormFile,
} from "bootstrap-vue";
import { UpdateALanguage, GetASingleLanguage } from "@/libs/Api/Language";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { quillEditor } from "vue-quill-editor";

export default {
  mounted() {
    this.getASingleLanguage();
  },
  data() {
    return {
      isLoading: false,
      languageDetails: null,
      imageFile: null,
      imagePreview: null,
      editorOption: {
        // Some Quill options...
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
    };
  },
  methods: {
    async getASingleLanguage() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleLanguage = new GetASingleLanguage(_this);
        getASingleLanguage.setRequestParam({ id: _this.$route.params.id });
        await getASingleLanguage.fetch((res) => {
          _this.languageDetails = res.data;
          if (_this.languageDetails.picUrl) {
            _this.imagePreview = `${this.baseUrl}/${_this.languageDetails.picUrl}`;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    deletePreviewImage() {
      URL.revokeObjectURL(this.imageFile);
      this.imagePreview = null;
      this.imageFile = null;
    },
    handleImageFile() {
      if (this.imageFile) {
        this.imagePreview = URL.createObjectURL(this.imageFile);
      }
    },
    createUpdateLanguagePayloadAsFormData() {
      const keysRequiredForUpdate = [
        "languageId",
        "title",
        "persianTitle",
        "description",
      ];
      let myFormData = new FormData();
      keysRequiredForUpdate.forEach((key) => {
        if (this.languageDetails[key] != null) {
          myFormData.append(key, this.languageDetails[key]);
        }
      });
      if (this.imageFile) {
        myFormData.append("MainPic", this.imageFile);
      }
      return myFormData;
    },
    async sendUpdateLanguageRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateALanguage = new UpdateALanguage(_this);
        updateALanguage.setFormData(
          _this.createUpdateLanguagePayloadAsFormData()
        );
        await updateALanguage.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "زبان با موفقیت ویرایش شد",
                icon: "EditIcon",
                variant: "success",
              },
            });
            _this.getASingleLanguage();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.data.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        }),
          (err) => {
            console.error(err);
          };
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BButton,
    BOverlay,
    BFormFile,
    quillEditor,
  },
};
</script>
